export default "__VITE_ASSET__BjlvEOTY__"